import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { Button, Alert } from '@resiliatech/birdsong'
import { useLoginAsMutation } from 'Generated/graphql-types'

export const Impersonate = () => {
  const [userId, setUserId] = useState<number | null>(null)
  const [loginAsMutation] = useLoginAsMutation({
    onCompleted: () => {
      // eslint-disable-next-line no-restricted-globals
      location.reload()
    },
  })

  const handleImpersonateClick = async () => {
    if (!userId) return
    localStorage.setItem('ImpersonationSession', 'yes')
    loginAsMutation({ variables: { userId } })
  }

  return (
    <Box
      sx={{ padding: '24px', maxWidth: '600px', backgroundColor: '#F0EEEB' }}
    >
      <Typography variant='h4' sx={{ mb: 3 }}>
        Impersonate
      </Typography>

      <Typography variant='body1' color='error' sx={{ mb: 4 }}>
        Notice: This will not work for the donations tool
      </Typography>

      <input
        type='text'
        placeholder='User Id'
        value={userId ? `${userId}` : ''}
        onChange={(event) => {
          setUserId(parseInt(event.target.value, 10))
        }}
      />

      <button type='button' onClick={handleImpersonateClick}>
        Go
      </button>
    </Box>
  )
}
